export const CARD_TYPES = {
  invitation: 'INVITATION',
  invitationEnvelope: 'INVITATION_ENVELOPE',
  std: 'SAVE_THE_DATE',
  dstd: 'DIGITAL_SAVE_THE_DATE',
  ctd: 'CHANGE_THE_DATE',
  thankyou: 'THANK_YOU',
  menu: 'MENU',
  program: 'PROGRAM',
  place: 'PLACE',
  holiday: 'HOLIDAY',
  enclosure: 'ENCLOSURE',
  rsvp: 'RSVP',
  rsvpEnvelope: 'RSVP_ENVELOPE',
};

export const CARD_SLUGS = {
  [CARD_TYPES.std]: 'save-the-date',
  [CARD_TYPES.dstd]: 'digital/save-the-date',
  [CARD_TYPES.ctd]: 'change-the-date',
  [CARD_TYPES.invitation]: 'invitations',
  [CARD_TYPES.thankyou]: 'thank-you-cards',
  [CARD_TYPES.menu]: 'menus',
  [CARD_TYPES.program]: 'programs',
  [CARD_TYPES.place]: 'place-cards',
  [CARD_TYPES.holiday]: 'holiday-cards',
  [CARD_TYPES.enclosure]: 'enclosures',
  DETAILS: 'enclosures',
};
